import { render } from "./Kanban.vue?vue&type=template&id=e2c9b600&scoped=true"
import script from "./Kanban.vue?vue&type=script&lang=js"
export * from "./Kanban.vue?vue&type=script&lang=js"

import "./Kanban.vue?vue&type=style&index=0&id=e2c9b600&scoped=true&lang=css"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c9b600"]])

export default __exports__